module.exports = __webpack_public_path__ + "media/images/page/top/mvSp-d0589c096477d88c740f7d3565531a80.jpg";